import React, { type FC } from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Body } from "@edreamsodigeo/prisma-design-system";

const GeneralTC: FC = () => {
  const { t } = useTranslation();

  return (
    <Body
      type="xxSmall"
      color="neutral.60"
      textDecoration="none"
      textAlign="center"
      sx={{ a: { color: "neutral.60" } }}
      dangerouslySetInnerHTML={{
        __html: t("authentication.footer.termsAndConditions"),
      }}
    />
  );
};

export default GeneralTC;
